<script lang="ts" setup>
defineProps<{
  withTitle?: boolean;
}>();
const emit = defineEmits<{
  (event: 'login'): void;
}>();
const authorizationTheme = inject(
  INJECTION_KEYS.AuthorizationTheme,
  ThemeEnum.dark,
);

const { t } = useI18n();
</script>

<template>
  <div>
    <h2 v-if="withTitle" class="authorizationComponent__title">
      {{ t('title') }}
    </h2>
    <span class="authorizationComponent__info">{{ t('info') }}</span>

    <BaseButton
      @click="emit('login')"
      type="button"
      class="authorizationComponent__submit"
      :dark="authorizationTheme === ThemeEnum.light"
    >
      {{ t('action') }}
    </BaseButton>
  </div>
</template>

<i18n>
ru:
  title: Восстановление пароля
  info: Письмо для восстановления пароля было отправлено вам на почту
  action: Войти

en:
  title: Password recovery
  info: A password recovery email has been sent to you
  action: Log in
</i18n>
